import { Input } from "antd";
import { FormCol } from "components/UI/Form/FormCol";
import { FormGrid } from "components/UI/Form/FormGrid";
import { AdvertiserSelectSearchable } from "components/UI/Selects/AdvertiserSelectSearchable/AdvertiserSelectSearchable.tsx";
import { CategorySelectSearchable } from "components/UI/Selects/CategorySelectSearchable/CategorySelectSearchable.tsx";
import { CountrySelectSearchable } from "components/UI/Selects/CountrySelectSearchable/CountrySelectSearchable.tsx";
import { CurrencySelectSearchable } from "components/UI/Selects/CurrencySelectSearchable/CurrencySelectSearchable.tsx";
import { LabelSelectSearchable } from "components/UI/Selects/LabelSelectSearchable/LabelSelectSearchable.tsx";
import { UploadFormItem } from "components/UI/UploadFormItem/UploadFormItem.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

import { OfferEditGeneralFormData } from "../formSchema";

interface AdvertiserSectionProps {
    control: Control<OfferEditGeneralFormData>;
    onLogoSelected: (file: File | null) => void; // null = logo cleared
}

export const AdvertiserSection: FC<AdvertiserSectionProps> = ({ control, onLogoSelected }) => {
    const { t: tF } = usePaldockTranslation("forms.offer-general-edit");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");

    return (
        <FormCol>
            <FormGrid cols={3}>
                <FormItem control={control} name="title" label={tFields("name.label")} required>
                    <Input />
                </FormItem>
                <FormItem control={control} name="visible_title" label={tF("fields.visible_title.label")} required>
                    <Input />
                </FormItem>
                <FormItem control={control} name="advertiser_id" label={tFields("advertiser.label")}>
                    <AdvertiserSelectSearchable />
                </FormItem>
            </FormGrid>
            <FormGrid cols={3}>
                <FormItem control={control} name="currency_id" label={tFields("currency.label")}>
                    <CurrencySelectSearchable />
                </FormItem>
                <FormItem control={control} name="country_id" label={tFields("country.label")}>
                    <CountrySelectSearchable allowClear />
                </FormItem>
                <UploadFormItem
                    control={control}
                    label={tF("fields.logo.label")}
                    name="logo"
                    onFileSelected={onLogoSelected}
                />
            </FormGrid>
            <FormGrid cols={3}>
                <FormItem control={control} name="category" label={tFields("category.label")}>
                    <CategorySelectSearchable allowClear />
                </FormItem>
                <FormItem control={control} name="label_ids" label={tFields("label.label")} className="col-span-2">
                    <LabelSelectSearchable mode="multiple" allowClear />
                </FormItem>
            </FormGrid>
        </FormCol>
    );
};
